import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { InputGroup } from "reactstrap";
// import { login } from "../services/login.js";
import "./css/style.css";
import "./css/font-awesome.min.css";
// import "./css/bootstrap.min.css";
// import "./dashboard.css";

// import Device from "../../assets/images/Device.png";

import axios from "axios";
import { environment } from "../../environment.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const Login2 = ({ history }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [value, setValues] = useState([]);

  const [emailErrors, setEmailErrors] = useState({});
  const [passwordErrors, setPasswordErrors] = useState({});

  useEffect(() => {
    if (localStorage.getItem("token")) {
      localStorage.setItem("alertArray", [
        { name: "co2", value: "104", ts: 1631048167382 },
      ]);
      history.push("/dashboard");
    } else {
      history.push("/");
    }
  }, []);

  const formValidation = () => {
    const emailErrors = {};
    const passwordErrors = {};
    let isValid = true;

    if (!email) {
      emailErrors.noEmail = "Email address required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailErrors.invalidEmail = "Email address is invalid";
      isValid = false;
    }
    if (!password) {
      passwordErrors.noPassword = "Password is required";
      isValid = false;
    }
    setEmailErrors(emailErrors);

    setPasswordErrors(passwordErrors);
    //setPasswordErrors(passwordErrors);
    return isValid;
  };

  const handleEyeButton = async () => {
    setPasswordShown(passwordShown ? false : true);
  };

  // const submitHandler = (e) => {
  //   const isValid = formValidation();

  //   e.preventDefault();
  //   if (isValid) {
  //     setLoading(true);

  //     if (!localStorage.getItem("token")) {
  //       history.push("/");
  //     }
  //     try {
  //       // login(email, password, history);
  //       console.log(email, password);
  //       let val = {};
  //       if (email == "japdata@diaq.in" && password == "dap_jap#@$12rt45") {
  //         val["username"] = "tenant_bbsr@diaq.in";
  //         val["password"] = "Bbsr@#$qwe123!#";
  //         localStorage.setItem("isDapJapan", true);
  //       } else if (email == "bbsrdata@diaq.in" && password == "bbsrD#@34apyu") {
  //         val["username"] = "tenant_bbsr@diaq.in";
  //         val["password"] = "Bbsr@#$qwe123!#";
  //         localStorage.setItem("isDapJapan", true);
  //       } else {
  //         val["username"] = email;
  //         val["password"] = password;
  //       }
  //       console.log(email, password);

  //       axios
  //         .post(environment.apiUrl + "auth/login", val)
  //         .then((res) => {
  //           try {
  //             if (!res.data.token) {
  //               console.log("auth failed");
  //             } else {
  //               let token = res.data.token;
  //               let refreshToken = res.data.refreshToken;

  //               axios
  //                 .get(environment.apiUrl + "auth/user", {
  //                   headers: { "X-Authorization": "Bearer " + res.data.token },
  //                 })
  //                 .then((res) => {
  //                   console.log(res);
  //                   //localStorage.setItem("userDetails", JSON.stringify(res));
  //                   let userDetails = JSON.stringify(res);
  //                   localStorage.setItem("alertArray", [
  //                     { name: "co2", value: "104", ts: 1631048167382 },
  //                   ]);
  //                   // history.push("/page/dashboardPage");

  //                   axios
  //                     .post(environment.dap_url + "webLogin/login", {
  //                       email: res.data.email,
  //                       userId: res.data.id.id,
  //                       userFirstName: res.data.firstName,
  //                       userEmail: res.data.email,
  //                       userLastName: res.data.lastName,
  //                       profileImageUrl: "",
  //                       webPushNotificationId: "",
  //                       userType: res.data.authority,
  //                       customerId: res.data.customerId.id,
  //                       tenantId: res.data.tenantId.id,
  //                     })
  //                     .then((res) => {
  //                       //setShowLoading(false)
  //                       // console.log(res.data);
  //                       if (res.data[0]?.userType == "PARTNER") {
  //                         localStorage.setItem("isPartnerLogin", true);
  //                         localStorage.setItem(
  //                           "partnerDetails",
  //                           JSON.stringify(res.data[0])
  //                         );
  //                       }
  //                       localStorage.setItem("token", token);
  //                       localStorage.setItem("refreshToken", refreshToken);
  //                       console.log(res);
  //                       localStorage.setItem("userDetails", userDetails);
  //                       history.push("/dashboard");
  //                     })
  //                     .catch((err) => {
  //                       console.log(err);
  //                       setLoading(false);

  //                       console.log(err);
  //                       MySwal.fire({
  //                         title: <p>Invalid username or password</p>,
  //                         type: "error",
  //                       });
  //                     });
  //                 });

  //               //console.log(res.data.token)
  //             }
  //           } catch (err) {
  //             setLoading(false);
  //             console.log(err.response);
  //             MySwal.fire({
  //               title: <p>Invalid username or password</p>,
  //               type: "error",
  //             });
  //           }
  //         })
  //         .catch((err) => {
  //           setLoading(false);
  //           console.log(err);
  //           MySwal.fire({
  //             title: <p>Authentication failed</p>,
  //             type: "error",
  //           });
  //         });
  //     } catch (err) {
  //       console.log(err);

  //       window.alert("error logging in");
  //       setLoading(false);
  //     }
  //   }
  // };
  const submitHandler = (e) => {
    const isValid = formValidation();

    e.preventDefault();
    if (isValid) {
      setLoading(true);

      if (!localStorage.getItem("token")) {
        history.push("/");
      }
      axios
        .post(environment.dap_url + "webLogin/checkOtherLogin", {
          email: email,
          password: password,
        })
        .then((res) => {
          console.log("check other login");
          // console.log("checking the response", res.data.data.userType);
          if (res.data.error == "Incorrect Password") {
            console.log("inside incorrect password");
            setLoading(false);
            MySwal.fire({
              title: <p>Invalid username or password</p>,
              type: "error",
            });
          }else if (res.data.error == "Not Internal User") {
            console.log("not an internal user");
            notLogisticManager();
          }else if (res.data.data.userType == "PARTNER") {
            localStorage.setItem("isPartnerLogin", true);
            let userData = res.data.data;

            localStorage.setItem(
              "user",
              JSON.stringify({
                _id: userData._id,
                userId: userData.userId,
                userFirstName: userData.userFirstName,
                userLastName: userData.userLastName,
                tenantId: userData.tenantId,
                email: userData.email,
                city: userData.city,
                country: userData.country,
                state: userData.state,
                createdById: userData.createdBy,
                parentId:userData.parentId
              })
            );
            localStorage.setItem(
              "partnerDetails",
              JSON.stringify(res.data.data)
            );
            localStorage.setItem(
              "o_token",
              JSON.stringify({
                token: res.data.token,
                refreshToken: res.data.refreshToken,
              })
            );
            localStorage.setItem("token", "xyz");
            const userDetails = {
              data: {
                id: {
                  entityType: "USER",
                  id: res.data.data._id,
                },
                createdTime: 1668147734189,
                additionalInfo: {
                  description: "",
                  defaultDashboardId: null,
                  defaultDashboardFullscreen: false,
                  homeDashboardId: null,
                  homeDashboardHideToolbar: true,
                  userPasswordHistory: {
                    1668147784562:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                    1668147784567:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                  },
                  userCredentialsEnabled: true,
                  failedLoginAttempts: 0,
                  lastLoginTs: 1668572428078,
                },
                tenantId: {
                  entityType: "TENANT", 
                  //change it according to the tenant id as only one tenant will be present 
                  id: "bece6c20-f95c-11ed-bfa6-85628fc0a3af",
                },
                customerId: {
                  entityType: "CUSTOMER",
                  id: "13814000-1dd2-11b2-8080-808080808080",
                },
                email: res.data.data.email,
                authority: "PARTNER",
                firstName: res.data.data.userFirstName,
                lastName: "",
                name: "anil123@gmail.com",
              },
              status: 200,
              statusText: "",
              headers: {
                "cache-control":
                  "no-cache, no-store, max-age=0, must-revalidate",
                "content-type": "application/json",
                expires: "0",
                pragma: "no-cache",
              },
              config: {
                url: "https://core.diaq.hhgs.in/api/auth/user",
                method: "get",
                headers: {
                  Accept: "application/json, text/plain, */*",
                  "X-Authorization":
                    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhbmlsMTIzQGdtYWlsLmNvbSIsInNjb3BlcyI6WyJURU5BTlRfQURNSU4iXSwidXNlcklkIjoiMmVjYzA1ZDAtNjE4OS0xMWVkLTllZmMtMWQyZGU0ZTNlMTIwIiwiZmlyc3ROYW1lIjoiQ2VudHJveHkiLCJsYXN0TmFtZSI6IiIsImVuYWJsZWQiOnRydWUsImlzUHVibGljIjpmYWxzZSwidGVuYW50SWQiOiIyZWFlYjlkMC02MTg5LTExZWQtOWVmYy0xZDJkZTRlM2UxMjAiLCJjdXN0b21lcklkIjoiMTM4MTQwMDAtMWRkMi0xMWIyLTgwODAtODA4MDgwODA4MDgwIiwiaXNzIjoidGhpbmdzYm9hcmQuaW8iLCJpYXQiOjE2Njg1NzI0MjgsImV4cCI6MTY2ODU4MTQyOH0.8ExDlzYFHtMG7TvOSrV88Wts_gZHLZ1UP8FCUoo9-bIa2esJC5VKqOY-_JjACY660_QOYqYnW_YbYJYNIZOq7g",
                },
                transformRequest: [null],
                transformResponse: [null],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
              },
              request: {},
            };

            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            const tenantdetails = {
              data: {
                id: {
                  entityType: "USER",
                  id: "623312b0-f969-11ed-bfa6-85628fc0a3af",
                },
                createdTime: 1663648110956,
                additionalInfo: {
                  description: "",
                  defaultDashboardId: null,
                  defaultDashboardFullscreen: false,
                  homeDashboardId: null,
                  homeDashboardHideToolbar: true,
                  userPasswordHistory: {
                    1663648154930:
                      "$2a$10$88SoOe9QsUH5uPaCb6ZRt.zl6vk3nZjRcfs8YWHjptzjPSg2Zyhgm",
                    1663648154943:
                      "$2a$10$88SoOe9QsUH5uPaCb6ZRt.zl6vk3nZjRcfs8YWHjptzjPSg2Zyhgm",
                  },
                  userCredentialsEnabled: true,
                  failedLoginAttempts: 0,
                  lastLoginTs: 1683113252203,
                },
                tenantId: {
                  entityType: "TENANT",
                  id: "bece6c20-f95c-11ed-bfa6-85628fc0a3af",
                },
                customerId: {
                  entityType: "CUSTOMER",
                  id: "13814000-1dd2-11b2-8080-808080808080",
                },
                email: "tenant_bbsr@diaq.in",
                authority: "TENANT_ADMIN",
                firstName: "Tenant ",
                lastName: "Bbsr",
                name: "tenant_bbsr@diaq.in",
              },
              status: 200,
              statusText: "",
              headers: {
                "cache-control":
                  "no-cache, no-store, max-age=0, must-revalidate",
                "content-type": "application/json",
                expires: "0",
                pragma: "no-cache",
              },
              config: {
                url: "https://core.diaq.hhgs.in/api/auth/user",
                method: "get",
                headers: {
                  Accept: "application/json, text/plain, /",
                  "X-Authorization":
                    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ0ZW5hbnRfYmJzckBkaWFxLmluIiwic2NvcGVzIjpbIlRFTkFOVF9BRE1JTiJdLCJ1c2VySWQiOiJhZTVhNGFjMC0zODljLTExZWQtODJiMy0xZDJkZTRlM2UxMjAiLCJmaXJzdE5hbWUiOiJUZW5hbnQgIiwibGFzdE5hbWUiOiJCYnNyIiwiZW5hYmxlZCI6dHJ1ZSwiaXNQdWJsaWMiOmZhbHNlLCJ0ZW5hbnRJZCI6Ijk4YjAwNzAwLTM4OWMtMTFlZC04MmIzLTFkMmRlNGUzZTEyMCIsImN1c3RvbWVySWQiOiIxMzgxNDAwMC0xZGQyLTExYjItODA4MC04MDgwODA4MDgwODAiLCJpc3MiOiJ0aGluZ3Nib2FyZC5pbyIsImlhdCI6MTY4MzExMzI1MiwiZXhwIjoxNjgzMTIyMjUyfQ.MtxWfhvLShBLRY5KOQGQx8FRvXdvp-VKc0ESFGk2w5zGXZthAkTqTuDQaYyvnJe-DPEUmqTSo5EnHPs34x3Qvg",
                },
                transformRequest: [null],
                transformResponse: [null],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
              },
              request: {},
            };
            localStorage.setItem(
              "tenantDetails",
              JSON.stringify(tenantdetails)
            );
            localStorage.setItem("alertArray", [
              JSON.stringify({ name: "co2", value: "104", ts: 1631048167382 }),
            ]);
            history.push("/dashboard");
          } else if (res.data.data.userType == "LEAD_EXECUTIVE") {
            console.log("inside lead-executive");
            let userData = res.data.data;

            localStorage.setItem(
              "user",
              JSON.stringify({
                _id: userData._id,
                userId: userData.userId,
                userFirstName: userData.userFirstName,
                userLastName: userData.userLastName,
                tenantId: userData.tenantId,
                email: userData.email,
                city: userData.city,
                country: userData.country,
                state: userData.state,
                createdById: userData.createdBy,
                parentId:userData.parentId
              })
            );
            localStorage.setItem(
              "executivedetails",
              JSON.stringify(res.data.data)
            );
            localStorage.setItem("isLeadExecutive",true)
            localStorage.setItem(
              "o_token",
              JSON.stringify({
                token: res.data.token,
                refreshToken: res.data.refreshToken,
              })
            );
            localStorage.setItem("token", "xyz");
            const userDetails = {
              data: {
                id: {
                  entityType: "USER",
                  id: res.data.data._id,
                },
                createdTime: 1668147734189,
                additionalInfo: {
                  description: "",
                  defaultDashboardId: null,
                  defaultDashboardFullscreen: false,
                  homeDashboardId: null,
                  homeDashboardHideToolbar: true,
                  userPasswordHistory: {
                    1668147784562:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                    1668147784567:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                  },
                  userCredentialsEnabled: true,
                  failedLoginAttempts: 0,
                  lastLoginTs: 1668572428078,
                },
                tenantId: {
                  entityType: "TENANT",
                  id: "2eaeb9d0-6189-11ed-9efc-1d2de4e3e120",
                },
                customerId: {
                  entityType: "CUSTOMER",
                  id: "13814000-1dd2-11b2-8080-808080808080",
                },
                email: res.data.data.email,
                authority: "leadexecutive",
                firstName: res.data.data.userFirstName,
                lastName: "",
                name: "anil123@gmail.com",
              },
              status: 200,
              statusText: "",
              headers: {
                "cache-control":
                  "no-cache, no-store, max-age=0, must-revalidate",
                "content-type": "application/json",
                expires: "0",
                pragma: "no-cache",
              },
              config: {
                url: "https://core.diaq.hhgs.in/api/auth/user",
                method: "get",
                headers: {
                  Accept: "application/json, text/plain, */*",
                  "X-Authorization":
                    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhbmlsMTIzQGdtYWlsLmNvbSIsInNjb3BlcyI6WyJURU5BTlRfQURNSU4iXSwidXNlcklkIjoiMmVjYzA1ZDAtNjE4OS0xMWVkLTllZmMtMWQyZGU0ZTNlMTIwIiwiZmlyc3ROYW1lIjoiQ2VudHJveHkiLCJsYXN0TmFtZSI6IiIsImVuYWJsZWQiOnRydWUsImlzUHVibGljIjpmYWxzZSwidGVuYW50SWQiOiIyZWFlYjlkMC02MTg5LTExZWQtOWVmYy0xZDJkZTRlM2UxMjAiLCJjdXN0b21lcklkIjoiMTM4MTQwMDAtMWRkMi0xMWIyLTgwODAtODA4MDgwODA4MDgwIiwiaXNzIjoidGhpbmdzYm9hcmQuaW8iLCJpYXQiOjE2Njg1NzI0MjgsImV4cCI6MTY2ODU4MTQyOH0.8ExDlzYFHtMG7TvOSrV88Wts_gZHLZ1UP8FCUoo9-bIa2esJC5VKqOY-_JjACY660_QOYqYnW_YbYJYNIZOq7g",
                },
                transformRequest: [null],
                transformResponse: [null],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
              },
              request: {},
            };
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            localStorage.setItem("alertArray", [
              JSON.stringify({ name: "co2", value: "104", ts: 1631048167382 }),
            ]);
            // localStorage.setItem("refreshToken", refreshToken);
            console.log(res);
            history.push("/dashboard");
          } else if (res.data.data.userType == "IT_EXECUTIVE") {
            let userData = res.data.data;

            localStorage.setItem(
              "user",
              JSON.stringify({
                _id: userData._id,
                userId: userData.userId,
                userFirstName: userData.userFirstName,
                userLastName: userData.userLastName,
                tenantId: userData.tenantId,
                email: userData.email,
                city: userData.city,
                country: userData.country,
                state: userData.state,
                createdById: userData.createdBy,
                parentId:userData.parentId
              })
            );
            localStorage.setItem("isItExecutive", true);
            localStorage.setItem(
              "executivedetails",
              JSON.stringify(res.data.data)
            );
            localStorage.setItem(
              "o_token",
              JSON.stringify({
                token: res.data.token,
                refreshToken: res.data.refreshToken,
              })
            );
            localStorage.setItem("token", "xyz");
            const userDetails = {
              data: {
                id: {
                  entityType: "USER",
                  id: res.data.data._id,
                },
                createdTime: 1668147734189,
                additionalInfo: {
                  description: "",
                  defaultDashboardId: null,
                  defaultDashboardFullscreen: false,
                  homeDashboardId: null,
                  homeDashboardHideToolbar: true,
                  userPasswordHistory: {
                    1668147784562:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                    1668147784567:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                  },
                  userCredentialsEnabled: true,
                  failedLoginAttempts: 0,
                  lastLoginTs: 1668572428078,
                },
                tenantId: {
                  entityType: "TENANT",
                  id: "2eaeb9d0-6189-11ed-9efc-1d2de4e3e120",
                },
                customerId: {
                  entityType: "CUSTOMER",
                  id: "13814000-1dd2-11b2-8080-808080808080",
                },
                email: res.data.data.email,
                authority: "itexecutive",
                firstName: res.data.data.userFirstName,
                lastName: "",
                name: "anil123@gmail.com",
              },
              status: 200,
              statusText: "",
              headers: {
                "cache-control":
                  "no-cache, no-store, max-age=0, must-revalidate",
                "content-type": "application/json",
                expires: "0",
                pragma: "no-cache",
              },
              config: {
                url: "https://core.diaq.hhgs.in/api/auth/user",
                method: "get",
                headers: {
                  Accept: "application/json, text/plain, */*",
                  "X-Authorization":
                    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhbmlsMTIzQGdtYWlsLmNvbSIsInNjb3BlcyI6WyJURU5BTlRfQURNSU4iXSwidXNlcklkIjoiMmVjYzA1ZDAtNjE4OS0xMWVkLTllZmMtMWQyZGU0ZTNlMTIwIiwiZmlyc3ROYW1lIjoiQ2VudHJveHkiLCJsYXN0TmFtZSI6IiIsImVuYWJsZWQiOnRydWUsImlzUHVibGljIjpmYWxzZSwidGVuYW50SWQiOiIyZWFlYjlkMC02MTg5LTExZWQtOWVmYy0xZDJkZTRlM2UxMjAiLCJjdXN0b21lcklkIjoiMTM4MTQwMDAtMWRkMi0xMWIyLTgwODAtODA4MDgwODA4MDgwIiwiaXNzIjoidGhpbmdzYm9hcmQuaW8iLCJpYXQiOjE2Njg1NzI0MjgsImV4cCI6MTY2ODU4MTQyOH0.8ExDlzYFHtMG7TvOSrV88Wts_gZHLZ1UP8FCUoo9-bIa2esJC5VKqOY-_JjACY660_QOYqYnW_YbYJYNIZOq7g",
                },
                transformRequest: [null],
                transformResponse: [null],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
              },
              request: {},
            };
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            localStorage.setItem("alertArray", [
              JSON.stringify({ name: "co2", value: "104", ts: 1631048167382 }),
            ]);
            // localStorage.setItem("refreshToken", refreshToken);
            console.log(res);
            history.push("/dashboard");
          } else if (res.data.data.userType == "SUPPORT_ADMIN") {
            console.log("inside support-admin");
            let userData = res.data.data;
            localStorage.setItem(
              "user",
              JSON.stringify({
                _id: userData._id,
                userId: userData.userId,
                userFirstName: userData.userFirstName,
                userLastName: userData.userLastName,
                tenantId: userData.tenantId,
                email: userData.email,
                city: userData.city,
                country: userData.country,
                state: userData.state,
                createdById: userData.createdBy,
                parentId:userData.parentId
              })
            );
            localStorage.setItem("isSupportAdmin", true);
            localStorage.setItem(
              "supportAdminDetails",
              JSON.stringify(res.data)
            );
            localStorage.setItem("token", "xyz");
            localStorage.setItem(
              "o_token",
              JSON.stringify({
                token: res.data.token,
                refreshToken: res.data.refreshToken,
              })
            );
            const userDetails = {
              data: {
                id: {
                  entityType: "USER",
                  id: res.data._id,
                },
                createdTime: 1668147734189,
                additionalInfo: {
                  description: "",
                  defaultDashboardId: null,
                  defaultDashboardFullscreen: false,
                  homeDashboardId: null,
                  homeDashboardHideToolbar: true,
                  userPasswordHistory: {
                    1668147784562:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                    1668147784567:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                  },
                  userCredentialsEnabled: true,
                  failedLoginAttempts: 0,
                  lastLoginTs: 1668572428078,
                },
                tenantId: {
                  entityType: "TENANT",
                  id: "2eaeb9d0-6189-11ed-9efc-1d2de4e3e120",
                },
                customerId: {
                  entityType: "CUSTOMER",
                  id: "13814000-1dd2-11b2-8080-808080808080",
                },
                email: res.data.email,
                authority: "supportadmin",
                firstName: res.data.userFirstName,
                lastName: "",
                name: "anil123@gmail.com",
              },
              status: 200,
              statusText: "",
              headers: {
                "cache-control":
                  "no-cache, no-store, max-age=0, must-revalidate",
                "content-type": "application/json",
                expires: "0",
                pragma: "no-cache",
              },
              config: {
                url: "https://core.diaq.hhgs.in/api/auth/user",
                method: "get",
                headers: {
                  Accept: "application/json, text/plain, */*",
                  "X-Authorization":
                    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhbmlsMTIzQGdtYWlsLmNvbSIsInNjb3BlcyI6WyJURU5BTlRfQURNSU4iXSwidXNlcklkIjoiMmVjYzA1ZDAtNjE4OS0xMWVkLTllZmMtMWQyZGU0ZTNlMTIwIiwiZmlyc3ROYW1lIjoiQ2VudHJveHkiLCJsYXN0TmFtZSI6IiIsImVuYWJsZWQiOnRydWUsImlzUHVibGljIjpmYWxzZSwidGVuYW50SWQiOiIyZWFlYjlkMC02MTg5LTExZWQtOWVmYy0xZDJkZTRlM2UxMjAiLCJjdXN0b21lcklkIjoiMTM4MTQwMDAtMWRkMi0xMWIyLTgwODAtODA4MDgwODA4MDgwIiwiaXNzIjoidGhpbmdzYm9hcmQuaW8iLCJpYXQiOjE2Njg1NzI0MjgsImV4cCI6MTY2ODU4MTQyOH0.8ExDlzYFHtMG7TvOSrV88Wts_gZHLZ1UP8FCUoo9-bIa2esJC5VKqOY-_JjACY660_QOYqYnW_YbYJYNIZOq7g",
                },
                transformRequest: [null],
                transformResponse: [null],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
              },
              request: {},
            };
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            localStorage.setItem("alertArray", [
              { name: "co2", value: "104", ts: 1631048167382 },
            ]);
            // localStorage.setItem("refreshToken", refreshToken);
            console.log(res);
            history.push("/dashboard");
          } else {
            console.log("in logistic-manager");
            let userData = res.data.data;
            localStorage.setItem(
              "user",
              JSON.stringify({
                _id: userData._id,
                userId: userData.userId,
                userFirstName: userData.userFirstName,
                userLastName: userData.userLastName,
                tenantId: userData.tenantId,
                email: userData.email,
                city: userData.city,
                country: userData.country,
                state: userData.state,
                createdById: userData.createdBy,
              })
            );
            localStorage.setItem("isLogisticManager", true);
            localStorage.setItem("managerdetails", JSON.stringify(res.data));
            localStorage.setItem("token", "xyz");
            localStorage.setItem(
              "o_token",
              JSON.stringify({
                token: res.data.token,
                refreshToken: res.data.refreshToken,
              })
            );
            const userDetails = {
              data: {
                id: {
                  entityType: "USER",
                  id: res.data.data._id,
                },
                createdTime: 1668147734189,
                additionalInfo: {
                  description: "",
                  defaultDashboardId: null,
                  defaultDashboardFullscreen: false,
                  homeDashboardId: null,
                  homeDashboardHideToolbar: true,
                  userPasswordHistory: {
                    1668147784562:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                    1668147784567:
                      "$2a$10$57qRl7favQHQRNu9W6Am2exbV6F5cJfwUeV5KsstMMCR7TRn0ylda",
                  },
                  userCredentialsEnabled: true,
                  failedLoginAttempts: 0,
                  lastLoginTs: 1668572428078,
                },
                tenantId: {
                  entityType: "TENANT",
                  id: "2eaeb9d0-6189-11ed-9efc-1d2de4e3e120",
                },
                customerId: {
                  entityType: "CUSTOMER",
                  id: "13814000-1dd2-11b2-8080-808080808080",
                },
                email: res.data.data.email,
                authority: "manager",
                firstName: res.data.data.userFirstName,
                lastName: "",
                name: "anil123@gmail.com",
              },
              status: 200,
              statusText: "",
              headers: {
                "cache-control":
                  "no-cache, no-store, max-age=0, must-revalidate",
                "content-type": "application/json",
                expires: "0",
                pragma: "no-cache",
              },
              config: {
                url: "https://core.diaq.hhgs.in/api/auth/user",
                method: "get",
                headers: {
                  Accept: "application/json, text/plain, */*",
                  "X-Authorization":
                    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhbmlsMTIzQGdtYWlsLmNvbSIsInNjb3BlcyI6WyJURU5BTlRfQURNSU4iXSwidXNlcklkIjoiMmVjYzA1ZDAtNjE4OS0xMWVkLTllZmMtMWQyZGU0ZTNlMTIwIiwiZmlyc3ROYW1lIjoiQ2VudHJveHkiLCJsYXN0TmFtZSI6IiIsImVuYWJsZWQiOnRydWUsImlzUHVibGljIjpmYWxzZSwidGVuYW50SWQiOiIyZWFlYjlkMC02MTg5LTExZWQtOWVmYy0xZDJkZTRlM2UxMjAiLCJjdXN0b21lcklkIjoiMTM4MTQwMDAtMWRkMi0xMWIyLTgwODAtODA4MDgwODA4MDgwIiwiaXNzIjoidGhpbmdzYm9hcmQuaW8iLCJpYXQiOjE2Njg1NzI0MjgsImV4cCI6MTY2ODU4MTQyOH0.8ExDlzYFHtMG7TvOSrV88Wts_gZHLZ1UP8FCUoo9-bIa2esJC5VKqOY-_JjACY660_QOYqYnW_YbYJYNIZOq7g",
                },
                transformRequest: [null],
                transformResponse: [null],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
              },
              request: {},
            };
            console.log("gaurav", userDetails);
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            localStorage.setItem("alertArray", [
              { name: "co2", value: "104", ts: 1631048167382 },
            ]);
            // localStorage.setItem("refreshToken", refreshToken);
            console.log(res);
            history.push("/dashboard");
          }
        });
    }
  };
  const notLogisticManager = () => {
    try {
      // login(email, password, history);
      console.log(email, password);
      let val = {};
      if (email == "japdata@diaq.in" && password == "dap_jap#@$12rt45") {
        console.log("inside japan data");
        val["username"] = "tenant_bbsr@diaq.in";
        val["password"] = "Bbsr@#$qwe123!#";
        localStorage.setItem("isDapJapan", true);
      } else if (email == "bbsrdata@diaq.in" && password == "bbsrD#@34apyu") {
        console.log("inside bbsr data");
        val["username"] = "tenant_bbsr@diaq.in";
        val["password"] = "Bbsr@#$qwe123!#";
        localStorage.setItem("isDapJapan", true);
      } else if (email == "daikinindia@gmail.com" && password == "daikin!@#") {
        console.log("inside bbsr data");
        val["username"] = "tenant_bbsr@diaq.in";
        val["password"] = "Bbsr@#$qwe123!#";
        localStorage.setItem("isDapJapan", true);
      } else if (email == "partnerdata@gmail.com" && password == "Partner@123") {
        console.log("inside bbsr data");
        val["username"] = "ajatusoffice123@gmail.com";
        val["password"] = "Bbsr@#$qwe123!#";
        localStorage.setItem("isDapJapan", true);
      } else {
        console.log("go ahead");
        val["username"] = email;
        val["password"] = password;
      }
      console.log(email, password);

      axios
        .post(environment.apiUrl + "auth/login", val)
        .then((res) => {
          console.log("checking auth login");
          console.log(res);
          try {
            if (!res.data.token) {
              console.log("auth failed");
            } else {
              console.log("token fetched successfully");
              let token = res.data.token;
              let refreshToken = res.data.refreshToken;

              axios
                .get(environment.apiUrl + "auth/user", {
                  headers: { "X-Authorization": "Bearer " + res.data.token },
                })
                .then((res) => {
                  console.log("fetched user data");
                  console.log(res);
                  //localStorage.setItem("userDetails", JSON.stringify(res));
                  let userDetails = JSON.stringify(res);
                  localStorage.setItem(
                    "alertArray",
                    JSON.stringify([
                      { name: "co2", value: "104", ts: 1631048167382 },
                    ])
                  );
                  // history.push("/page/dashboardPage");

                  axios
                    .post(environment.dap_url + "webLogin/login", {
                      email: res.data.email,
                      userId: res.data.id.id,
                      userFirstName: res.data.firstName,
                      userEmail: res.data.email,
                      userLastName: res.data.lastName,
                      profileImageUrl: "",
                      webPushNotificationId: "",
                      userType: res.data.authority,
                      customerId: res.data.customerId.id,
                      tenantId: res.data.tenantId.id,
                      password: password,
                    })
                    .then((resp) => {
                      //setShowLoading(false)
                      console.log(resp.data);
                      console.log("fetched data from local");

                      let userData = resp.data.data;

                      localStorage.setItem(
                        "user",
                        JSON.stringify({
                          _id: userData._id,
                          userId: userData.userId,
                          userFirstName: userData.userFirstName,
                          userLastName: userData.userLastName,
                          tenantId: userData.tenantId,
                          email: userData.email,
                          city: userData.city,
                          country: userData.country,
                          state: userData.state,
                          createdById: userData.createdBy,
                          parentId: userData.parentId
                        })
                      );

                      if (resp.data.data.userType == "PARTNER") {
                        localStorage.setItem("isPartnerLogin", true);
                        localStorage.setItem(
                          "partnerDetails",
                          JSON.stringify(resp.data.data)
                        );
                      }

                      localStorage.setItem("token", token);
                      localStorage.setItem("refreshToken", refreshToken);
                      localStorage.setItem(
                        "o_token",
                        JSON.stringify(resp.data.o_token)
                      );
                      console.log(resp);
                      localStorage.setItem("userDetails", userDetails);
                      history.push("/dashboard");
                    })
                    .catch((err) => {
                      console.log(err);
                      setLoading(false);

                      console.log(err);
                      MySwal.fire({
                        title: <p>Invalid username or password</p>,
                        type: "error",
                      });
                    });
                });

              //console.log(res.data.token)
            }
          } catch (err) {
            setLoading(false);
            console.log(err);
            MySwal.fire({
              title: <p>Invalid username or password</p>,
              type: "error",
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          MySwal.fire({
            title: <p>Authentication failed</p>,
            type: "error",
          });
        });
    } catch (err) {
      console.log(err);

      window.alert("error logging in");
      setLoading(false);
    }
  };
  return (
    <>
      <section class="login-sec">
        <div class="container">
          <div class="row">
            <form onSubmit={submitHandler}>
              <div class="dap-login-form">
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div class="dap-login-logo">
                      <img src="./assets/images/dap-logo-blue.png" alt="" />
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="dap-login-logo">
                      <p>Login to</p>
                      <h2>
                        <span>See</span> What you inhale!
                      </h2>
                    </div>
                  </div>
                  {/* <form onSubmit={submitHandler}> */}
                  <div class="col-lg-12 col-md-12">
                    <div class="dap-login-field">
                      <div class="input-group flex-nowrap">
                        <span class="input-group-text" id="addon-wrapping">
                          <i class="fa fa-envelope" aria-hidden="true"></i>
                        </span>

                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail"
                          placeholder="johndoe@gmail.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          style={{ color: "black" }}
                        />
                      </div>
                      <div>
                        {Object.keys(emailErrors).map((key) => {
                          return (
                            <div style={{ color: "red" }}>
                              {emailErrors[key]}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="dap-login-field">
                      <div class="input-group flex-nowrap">
                        <span class="input-group-text" id="addon-wrapping">
                          <i class="fa fa-key" aria-hidden="true"></i>
                        </span>
                        <input
                          type={passwordShown ? "text" : "password"}
                          className="form-control"
                          id="exampleInputPassword"
                          placeholder="*******"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={{ color: "black" }}
                        />
                        <span className="input-group-text"  onClick={handleEyeButton}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={passwordShown ? "fa fa-eye-slash" : "fa fa-eye"}
                            aria-hidden="true"
                          ></i>
                        </span>
                      </div>

                      <div>
                        {Object.keys(passwordErrors).map((key) => {
                          return (
                            <div style={{ color: "red" }}>
                              {passwordErrors[key]}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12 col-md-12">
                    <Button
                      type="submit"
                      className="btn btn-primary dap-cstm-login-btn"
                      //onClick={fetchData}
                      // onClick={setLoading(true)}
                      disabled={loading}
                    >
                      LOGIN{" "}
                      {loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      {loading && <span></span>}
                      {!loading && <span></span>}
                    </Button>
                  </div>
                  {/* <div class="col-lg-12 col-md-12">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label class="form-check-label" for="flexCheckDefault">
                        Remember me!
                      </label>
                    </div>
                  </div> */}
                  <div class="col-lg-12 col-md-12">
                    <div class="dap-forget-pswrd">
                      <a href="forgotPassword">Forgot Password?</a>
                    </div>
                  </div>

                  {/* </form> */}

                  {/* end */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login2;
